
    import {Component, Vue, Watch} from "vue-property-decorator";
    import statisticApi from "@/api/statistic";
    import echarts from "echarts";

    const {CodeToText, regionData} = require("@/js/region/region");
    import {dictApi} from "@/api/organization";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import utils from "@/common/utils"

    @Component({
        name: "Audit_Index",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        mode = ''; // or Inspect_Receive_Order   强检器具报检申请统计 or 接收报检强检器具业务统计
        modeType = 'Table';// Table or Chart
        dataList = []; //数据列表
        CodeToText = CodeToText;
        regionData = regionData;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        mechanismLevelList = []; //单位级别
        levelData = {};
        totalCount = 0;
        propParam = {
            mechanismName: '', //机构名称
            mechanismRegion: '', //机构区域
            mechanismLevel: '', //机构级别
            mechanismTypes: [], //单位类型
            startTime: '',
            endTime: '',
        } as any;
        tableKey = 0;
        tabCol = [];
        loading = false;
        private exportExcel: any;
        myChart = null as any;
        showForm = false;

        mounted() {

            //单位区域
            // statisticApi.getMechanismRegion().then((r) => {
            //     const regionCode = r.data.data;
            //     if(regionCode == null){
            //         this.regionData = regionData;
            //     }else{
            //         const region = this.getRegionData(regionCode, regionData);
            //         this.regionData = [ region ];
            //     }
            // });

            //单位级别
            dictApi.listDictItem({typeCode: "dwjb"}).then((r) => {
                if (r.data.result === 0) {
                    const levels = r.data.data;
                    this.mechanismLevelList = r.data.data;
                    this.levelData = Object.fromEntries(levels.map((item: any) => [item.dictKey, item]));
                }
            });
            this.mode = this.$route.params.mode;
            this.loadDataList(null);
        }
        sortByAcceptedRate(a: any, b: any){
            return utils.numToFixed((a.acceptedInstrCount / a.receiveInstrCount) * 100) - utils.numToFixed((b.acceptedInstrCount / b.receiveInstrCount) * 100);
        }
        sortByFinishRate(a: any, b: any){
            return utils.numToFixed((a.finishInstrCount / a.receiveInstrCount) * 100) - utils.numToFixed((b.finishInstrCount / b.receiveInstrCount) * 100);
        }
        getRegionData(regionCode: number, projectList: any) : any{
            for (let i = 0; i < projectList.length; i++) {
                let treeItem= projectList[i]
                if(treeItem.value === regionCode ){
                    return treeItem
                }else{
                    if(treeItem.children && treeItem.children.length>0){
                        const res = this.getRegionData(regionCode, treeItem.children);
                        if(res){
                            return res;
                        }
                    }
                }
            }
        }

        refresh(){
            this.loadDataList(null);
        }
        reset(){
          const form = this.$refs['form'] as HTMLFormElement;
          if (form) {
            form.resetFields();
          }
            this.refresh();
        }

        switchBtn() {
            if (this.modeType == "Chart") {
                this.modeType = "Table";
            } else {
                this.modeType = "Chart";
                this.$nextTick(() => {
                    this.loadEchartPie();
                });
            }
        }

        getType() {
            if (['Inspect_App_Order', 'Inspect_Receive_Order'].indexOf(this.mode) > -1) {
                return this.mode;
            } else {
                return "Inspect_Classify_Order"
            }
        }

        calcTitle() {
            if (this.mode === 'Inspect_App_Order') {
                return "本区域各检定机构接收及办理报检申请统计报表";
            } else if (this.mode === 'Inspect_Receive_Order') {
                return "本区域各检定机构接收报检强检器具业务统计报表";
            } else if (this.mode === 'Inspect_Receive_Classify_Order') {
                return "本区域各机构全部强检器具业务分类统计报表";
            } else if (this.mode === 'Inspect_Not_Accepted_Order') {
                return "本区域各机构未受理强检器具业务分类统计报表";
            } else if (this.mode === 'Inspect_Accepted_Order') {
                return "本区域各机构已受理强检器具业务分类统计报表";
            } else if (this.mode === 'Inspect_Finish_Order') {
                return "本区域各机构已检定强检器具业务分类统计报";
            } else if (this.mode === 'Inspect_Not_Match_Instr') {
                return "本区域各机构报检无匹配强检器具分类统计";
            }
        }

        loadDataList(callback: any) {
            this.loading = true;
            const propParam = this.propParam;
            const params = {
              mechanismName: propParam.mechanismName,
              mechanismRegion: propParam.mechanismRegion,
              mechanismLevel: propParam.mechanismLevel,
              mechanismTypes: propParam.mechanismTypes.join(","),
              startTime: propParam.startTime,
              endTime: propParam.endTime
            } as any;
            let api = null;
            if (this.mode === 'Inspect_App_Order') {
                api = statisticApi.listInspectInstrAppGroupByMechanism(params);
            } else if (this.mode === 'Inspect_Receive_Order') {
                api = statisticApi.listAcceptInspectInstrStatis(params);
            } else if (this.mode === 'Inspect_Receive_Classify_Order') {
                api = statisticApi.listInspectInstrAppGroupByCatalogue(params);
            } else if (this.mode === 'Inspect_Not_Accepted_Order') {
                params.checkResult = 3;
                api = statisticApi.listInspectInstrAppGroupByCatalogue(params);
            } else if (this.mode === 'Inspect_Accepted_Order') {
                params.checkResult = 8;
                api = statisticApi.listInspectInstrAppGroupByCatalogue(params);
            } else if (this.mode === 'Inspect_Finish_Order') {
                params.checkResult = 1;
                api = statisticApi.listInspectInstrAppGroupByCatalogue(params);
            } else if (this.mode === 'Inspect_Not_Match_Instr') {
                params.checkResult = 7;
                api = statisticApi.listInspectInstrAppGroupByCatalogue(params);
            } else {
                api = statisticApi.listInspectInstrAppGroupByMechanism(params);
            }
            api.then((r: any) => {
                if (r.data.result === 0) {
                    this.dataList = r.data.data;
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.loading = false;
                        }, 500);
                        this.loadEchartPie();
                    });
                    if (callback) {
                        callback();
                    }
                }
            });
        }

        onExportExcel() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.exportExcel(() => {
                loading.close();
            }, this.calcTitle() + ".xlsx");
        }

        onCommand(e: any) {
            this.mode = e;
            this.modeType = "Table";
            this.loadDataList(null);
        }

        changeTabCol(e: any) {
            console.log("changeTabCol");
            this.tabCol = e;
            this.$nextTick(() => {
                let $table = this.$refs.table as HTMLFormElement;
                if ($table) {
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }

        loadEchartPie() {
            if (this.mode !== "Inspect_Receive_Order" || this.modeType != 'Chart') return;
            const dataList = this.dataList;
            const dHeight = dataList.length * 20;
            const el = this.$refs['chart'] as HTMLDivElement;
            el.style.height = dHeight + "px";
            this.$nextTick(() => {
                let series = [{
                    name: "接收报检器具数量",
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: false,
                        }
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: [],
                }, {
                    name: "已受理器具数量",
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: false,
                        }
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: [],

                }, {
                    name: "已检定器具数量",
                    type: 'bar',
                    stack: 'total',
                    label: {
                        normal: {
                            show: false,
                        }
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: [],
                },
                  {
                    name: "总量",
                    type: 'line',
                    symbol: 'circle',//拐点样式
                    symbolSize: 18,//拐点大小
                    itemStyle: {
                      normal: {
                        lineStyle: {
                          width: 3,//折线宽度
                          color: "#27dba0"//折线颜色
                        },
                        color: '#27dba0',//拐点颜色
                        borderColor: '#fff',//拐点边框颜色
                        borderWidth: 3//拐点边框大小
                      },
                      emphasis: {
                        color: '#4CCEFE'//hover拐点颜色定义
                      }
                    },
                    data: []
                  }
                ] as any;
                let yAxisData = [] as any;
                dataList.forEach((d: any) => {
                    yAxisData.push(d.mechanismName);
                    series[0].data.push(d.receiveInstrCount);
                    series[1].data.push(d.acceptedInstrCount);
                    series[2].data.push(d.finishInstrCount);
                    series[3].data.push(d.receiveInstrCount + d.acceptedInstrCount + d.finishInstrCount);
                });
                if (this.myChart) {
                    this.myChart.dispose();
                }
                this.myChart = echarts.init(this.$refs['chart']);
                this.myChart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    color:['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        show: false,
                    },
                    yAxis: {
                        type: 'category',
                        data: yAxisData
                    },
                    series: series
                });
            });
        }
    }
